import React from "react";
import { makeStyles } from "@mui/styles";
import { IconButton, Typography } from "@mui/material";
const useStyles = makeStyles(() => ({
  cardContainer: {
    display: "flex",
    flexWrap: "wrap",
    // justifyContent: "space-between",
    marginTop: "20px",
  },
  card: {
    flexBasis: "calc(24% - 5px)",
    margin: "0 3px 20px",
    boxSizing: "border-box",
  },
  cardButton: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    padding: "4px",
    borderRadius: "5px",
  },
  cardIcon: {
    width: "50px",
    height: "50px",
    borderRadius: "5px",
  },
  cardTitle: {
    marginTop: "10px",
    color: "#000",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "8px !important",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
}));

const CardButton = ({ label, icon, onClick }) => {
  const classes = useStyles();
  const handleClick = () => {
    onClick();
  };

  let iconImage;
  if (typeof icon === "string") {
    iconImage = <img src={icon} alt={label} className={classes.cardIcon} />;
  } else {
    iconImage = icon;
  }

  return (
    <div className={classes.card}>
      <IconButton className={classes.cardButton} onClick={handleClick}>
        {iconImage}
      </IconButton>
      <Typography className={classes.cardTitle}>{label}</Typography>
    </div>
  );
};

const CardButtonGroup = ({ buttons, t }) => {
  const classes = useStyles();
  const itemsPerRow = 4;
  const rows = Math.ceil(buttons.length / itemsPerRow);

  return (
    <div className={classes.cardContainer}>
      {buttons.map((button, index) => (
        <CardButton
          key={index}
          label={t(button.label)}
          icon={button.icon}
          onClick={button.onClick}
        />
      ))}
      {Array(itemsPerRow * rows - buttons.length)
        .fill(null)
        .map((_, index) => (
          <div key={`empty-${index}`} className={classes.card} />
        ))}
    </div>
  );
};

export default CardButtonGroup;
